// removed by extract-text-webpack-plugin
module.exports = {"file":"_7477952b","filename":"_55bb99f9","card":"d6e46b14","meta":"bb499e3b","content":"_81557cca"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientHealthboard/PatientPortal/DataList/Card/EncounterCard/index.styl
// module id = 5046
// module chunks = 39